// Espejo frontend del catálogo de navegación. El backend resuelve la barra como
// listas de `id` + metadatos serializables (incluido `iconName` como string).
// Aquí mapeamos ese string al componente de `lucide-react`. NO importa código de
// backend: los strings `iconName` son el contrato entre ambos lados.
import {
  AtSign,
  Bell,
  Bot,
  Building2,
  ChartColumn,
  ClipboardList,
  Code2,
  CreditCard,
  Filter,
  Gauge,
  Github,
  Handshake,
  KeyRound,
  LayoutGrid,
  LifeBuoy,
  ListTodo,
  LockKeyhole,
  Mail,
  Megaphone,
  MessageCircle,
  MessageSquare,
  MessagesSquare,
  Package,
  Paintbrush,
  Palette,
  PenLine,
  Plug2,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  Star,
  Store,
  Tags,
  Target,
  Ticket,
  User,
  UserCog,
  Users,
  Webhook,
  Zap,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const NAV_ICONS: Record<string, LucideIcon> = {
  // Destinos de la barra principal.
  MessageCircle,
  MessagesSquare,
  Mail,
  AtSign,
  ClipboardList,
  Users,
  Handshake,
  Sparkles,
  Ticket,
  LifeBuoy,
  Bot,
  ChartColumn,
  Plug2,
  // Subpáginas de Configuración.
  User,
  LockKeyhole,
  Palette,
  Bell,
  KeyRound,
  Code2,
  MessageSquare,
  Building2,
  CreditCard,
  ShieldCheck,
  UserCog,
  Megaphone,
  PenLine,
  Tags,
  Filter,
  Webhook,
  Star,
  ListTodo,
  Gauge,
  Paintbrush,
  Target,
  Zap,
  Package,
  Store,
  Github,
  SlidersHorizontal,
  // Icono del lanzador / fallback.
  LayoutGrid,
};

export function navIcon(name: string): LucideIcon {
  return NAV_ICONS[name] ?? LayoutGrid; // fallback seguro
}
